export const otpApi = {
  // provider: 'phone' | 'email'
  verify: ({ provider, countryCode, phone, email }) => ({
    url: 'v2/:clientId/otp-verification-point/verify',
    method: 'post',
    params: { provider, countryCode, phone, email },
  }),
  acknowledge: ({ request_id, code }) => ({
    url: 'v2/:clientId/otp-verification-point/acknowledge',
    method: 'post',
    params: {
      request_id,
      code,
    },
  }),
  resetOtp: ({ request_id }) => ({
    url: 'v2/:clientId/otp-verification-point/reset-otp',
    method: 'post',
    params: {
      request_id,
    },
  }),
}
